<template>
  <MLangToggleButton
    v-if="showLangToggleButton"
    class="fixed top-2 right-4 sm:right-12"
  />
  <div v-if="showBottomNav" class="h-screen flex flex-col justify-end">
    <div class="flex-1 overflow-y-scroll overflow-x-hidden">
      <slot />
    </div>
    <m-bottom-nav v-if="!isInMingakuStudentApp" class="flex-none" />
  </div>
  <slot v-else />
</template>

<script lang="ts">
import MBottomNav from "@/components/MBottomNav.vue";
import store from "@/store";
import { Options, Vue } from "vue-class-component";
import MLangToggleButton from "@/components/MLangToggleButton.vue";

@Options({
  components: {
    MBottomNav,
    MLangToggleButton
  }
})
export default class MPageTemplate extends Vue {
  get isInLiff(): boolean {
    return store.state.isInLiff;
  }

  get isInMingakuStudentApp(): boolean {
    return store.state.isInMingakuStudentApp;
  }

  get showBottomNav(): boolean {
    if (this.$route.meta.pageType === "other") {
      return false;
    }
    return !this.isInLiff || !this.isInMingakuStudentApp;
  }

  get showLangToggleButton(): boolean {
    return this.$route.meta.showLangToggleButton ?? false;
  }
}
</script>

<style>
.todo-reflection-best {
  filter: invert(21%) sepia(100%) saturate(2153%) hue-rotate(287deg)
    brightness(113%) contrast(143%);
}
.todo-reflection-good {
  filter: invert(49%) sepia(61%) saturate(1801%) hue-rotate(197deg)
    brightness(102%) contrast(101%);
}
.todo-reflection-bad {
  filter: invert(29%) sepia(4%) saturate(12%) hue-rotate(343deg) brightness(97%)
    contrast(86%);
}
</style>
